type InvitationTokenStatus = "ACCEPTED" | "REJECTED";

type InvitationTokenClaims = Record<string, unknown>;

function decodeBase64Url(value: string): string | null {
  const paddingLength = (4 - (value.length % 4)) % 4;
  const paddedValue = `${value.replace(/-/g, "+").replace(/_/g, "/")}${"=".repeat(
    paddingLength,
  )}`;

  try {
    const binary = globalThis.atob(paddedValue);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch {
    return null;
  }
}

function decodeInvitationTokenClaims(
  token?: string | null,
): InvitationTokenClaims | null {
  if (!token) return null;

  const [, payload] = token.split(".");
  if (!payload) return null;

  const decodedPayload = decodeBase64Url(payload);
  if (!decodedPayload) return null;

  try {
    return JSON.parse(decodedPayload) as InvitationTokenClaims;
  } catch {
    return null;
  }
}

// The token signature is intentionally NOT verified here — this status is only
// used to decide whether to route to the accepted vs. rejected page. The real
// authority is the dev-plane AcceptInvitation call, which validates the token
// server-side. Do not extend this helper to gate sensitive client actions on
// the unverified claim.
export function getInvitationTokenStatus(
  token?: string | null,
): InvitationTokenStatus | null {
  const claims = decodeInvitationTokenClaims(token);
  const status = claims?.sts;
  if (typeof status !== "string") return null;

  const normalizedStatus = status.toUpperCase();
  if (normalizedStatus === "ACCEPTED" || normalizedStatus === "REJECTED") {
    return normalizedStatus;
  }

  return null;
}
